import { render, staticRenderFns } from "./AddPlayer.vue?vue&type=template&id=3509bf09&scoped=true&"
import script from "./AddPlayer.vue?vue&type=script&lang=js&"
export * from "./AddPlayer.vue?vue&type=script&lang=js&"
import style0 from "./AddPlayer.vue?vue&type=style&index=0&id=3509bf09&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509bf09",
  null
  
)

component.options.__file = "AddPlayer.vue"
export default component.exports